// @ts-nocheck
import React, { useEffect } from "react";
import { genders } from "src/constants/account";
import { Field } from "src/components/Forms/Field";
import { FormikProps } from "formik";
import { FormikCheckbox } from "src/components/Forms/Checkbox";
import { CheckboxStyle, RemoveIcon } from "../../../Wrapper";

interface Props {
  formProps: FormikProps<any>;
  clearFilterKey: (key: string) => void;
}

const GenderAudience: React.FC<Props> = ({ formProps, clearFilterKey }) => {
  let isVisible = false;

  if (
    (formProps?.values?.audienceGender || []).length > 0 &&
    (formProps?.values?.audienceGender || [])?.[0]?.key !== ""
  ) {
    isVisible = true;
  }

  let selectedData =
    (formProps?.values?.audienceGender || [])
      .map(item => item?.key)
      .filter(v => v !== "") || [];

  useEffect(() => {
    let simpleGenderAudience = [] as any;
    simpleGenderAudience = (selectedData || []).map(item => {
      let container = {} as any;
      container.key = item;
      return container;
    });

    formProps.setFieldValue("audienceGender", simpleGenderAudience);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Field
      label="Gender:"
      mb={20}
      color="black"
      isBeside={true}
      extra={
        isVisible && (
          <RemoveIcon
            type="close-circle"
            onClick={() => {
              formProps?.setFieldValue("audienceGender", [{ key: "" }]);
              clearFilterKey("audienceGender");
            }}
            style={{ marginTop: "-1px", marginLeft: "10px" }}
          />
        )
      }
      id="genderBreakdown"
    >
      <FormikCheckbox
        name="genderAudience"
        data={genders}
        style={CheckboxStyle}
        value={selectedData}
        onChange={v => {
          let genderAudience = [] as any;
          genderAudience = (v || []).map(item => {
            let container = {} as any;
            container.key = item;
            return container;
          });
          formProps.setFieldValue("audienceGender", genderAudience);
        }}
      />
    </Field>
  );
};

export default GenderAudience;
